import React from 'react'

export const NotFound = () => {
    return (
        <>

            <div className="not-found-wrapper">
                <div className="container">
                    <div className="animation">
                        <iframe src="https://lottie.host/embed/9181801f-81e8-4eb5-a737-96453fa6b6d6/DScddP6YTq.json"></iframe>
                    </div>

                    <div className="text-wrap text-center">
                        <p>Page not found</p>
                    </div>

                </div>
            </div>


        </>
    )
}
